import { FC } from 'react';

import IconInfo from 'src/assets/images/icons/info-circle-dark.svg';
import { INotifDetailSectionOtherProps } from './types';
import { NotificationDetailSection } from './Section';

/**
 * Component to display "Other" section containing files that:
 * - Are not recognized as invoices
 * - Have missing required fields
 * - Have resolution issues
 */
export const NotificationDetailSectionOther: FC<INotifDetailSectionOtherProps> = (props) => {
  const { data, children, defaultExpanded = true } = props;

  return (
    <NotificationDetailSection
      defaultExpanded={defaultExpanded}
      header={
        <div className='flex items-center gap-16'>
          <div className='w-[28px] h-[28px] rounded-full bg-[#EBEEF0] border border-[#597282] flex items-center justify-center'>
            <img src={IconInfo} className='w-[16px]' alt='' />
          </div>
          <div className='flex items-center gap-8'>
            <strong className='text-16 font-bold'>Other</strong>
            <div className='w-4 h-4 bg-blue_grey-30 rounded-full' />
            <div className='text-14 font-bold'>
              {data?.invoiceGroups?.reduce((count, invoiceGroup) => count + (invoiceGroup.invoiceFileProcessingStatusList?.length || 0), 0) || 0} items
            </div>
          </div>
        </div>
      }
    >
      {children}
    </NotificationDetailSection>
  );
};
